import React from 'react'
import {FormattedMessage} from 'react-intl'
import {ExamResult as ExamResultModel} from "@yaak/components/services/api/api";
import Badge from "@yaak/components/src/Badge";
import {BadgeType} from "@yaak/components/src/Badge/Badge";
import PostAddIcon from '@mui/icons-material/PostAdd';

interface ExamResultProps {
  examResults: Map<string, ExamResultModel[]> | {[licenseCode: string]: ExamResultModel[]} | null
}

type PassedExams = {
  [key: string]: boolean
}

const ExamResult: React.FunctionComponent<ExamResultProps> = ({
  examResults,
}) => {
  const passedExams: PassedExams = {}
  
  if (!examResults) {
    return (
      <div>
        <Badge label={<><PostAddIcon/></>} type={BadgeType.blue}/>
      </div>
    )
  }
  
  // Convert Map to object if needed
  const resultsObj = examResults instanceof Map ? 
    Object.fromEntries(examResults.entries()) : 
    examResults
  
  Object.entries(resultsObj).forEach(([key, value]) => {
    const passedAnExam = value.some((examResult: ExamResultModel) => examResult.passed)
    passedExams[key] = passedAnExam
  })

  return (
    <div
    >
      { Object.keys(passedExams).length === 0 ? (
          <Badge label={<><PostAddIcon/></>} type={BadgeType.blue}/>
      ) : (
          Object.entries(passedExams).map(([licenseType, passed]) => {
            let badgeType = BadgeType.green
            let messageId = 'add_exam_dialog.passed'
            if (!passed) {
              badgeType = BadgeType.red
                messageId = 'add_exam_dialog.failed'
            }
            const badgeLabel = <>
              {licenseType}: <FormattedMessage id={messageId} />
            </>
            return (
                <Badge key={licenseType} label={badgeLabel} type={badgeType} />
            )
          }))
      }
    </div>
  )
}

export default ExamResult
